import React from "react";
import { useI18n } from "../i18n/I18nProvider";
import { MISSION } from "../constants/testIds";
import { Reveal, WordsReveal } from "../components/Reveal";

export const Mission = () => {
  const { t } = useI18n();
  return (
    <section
      id="mission"
      data-testid={MISSION.section}
      className="relative bg-black py-32 md:py-48 lg:py-56 px-6 md:px-10 lg:px-14"
    >
      <div className="mx-auto max-w-[1440px]">
        <Reveal>
          <div className="flex items-center gap-4 text-[10px] tracking-[0.4em] uppercase font-mono text-white/50">
            <span className="w-8 h-px bg-white/30" />
            {t.mission.eyebrow}
          </div>
        </Reveal>

        <h2
          data-testid={MISSION.statement}
          className="mt-10 md:mt-16 font-display tracking-display text-white text-[40px] sm:text-[56px] md:text-[80px] lg:text-[104px] leading-[0.98] font-medium max-w-[1200px]"
        >
          <span className="block"><WordsReveal text={t.mission.line1} /></span>
          <span className="block"><WordsReveal text={t.mission.line2} delay={0.05} /></span>
          <span className="block text-white/55"><WordsReveal text={t.mission.line3} delay={0.1} /></span>
        </h2>

        <Reveal delay={0.4}>
          <p className="mt-16 max-w-[620px] text-white/65 text-[15px] md:text-[17px] leading-[1.65]">
            {t.mission.sub}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Mission;
